import { Injectable } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../_models/user.interface';
import { AppConfig } from '../_helpers/appconfig.service';
import { ChangePassword, ForgotPassword, ICustomer, UserCustomerDetail } from '../_models';
import { map, tap } from 'rxjs/operators';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Auth0Domains } from '../sharedcomp/constans/auth-domain.constans';

@Injectable()
export class UserService {

    _kcmssvcURL: string = AppConfig.settings.apiServer.kcmssvcURL.toString();
    private auth0ProdDomain = 'https://kashio.auth0.com';
    private authCurrentDomain: string;
    httpOptions: any;

  constructor(
    protected httpClient: HttpClient
  ) {
    let token = localStorage.getItem("id_token");
    this.httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + token,
        'Content-Type': 'application/json'
      })
    };

    this.authCurrentDomain = this.setAuth0Domain(AppConfig.settings.auth0config.domain);
  }

  private setAuth0Domain(domain: string) {
    const domainUrl = Auth0Domains[domain];
    return domainUrl ? domainUrl : this.auth0ProdDomain;
  }

    /**
     * create_user
     * Create a User
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createUser(body: User, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createUser.');
        }

        return this.httpClient.post<User>(`${this._kcmssvcURL}/users`,
            body,
            {

            }
        );
    }//end

    /**
     * get_user
     *
     * @param publicId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */

    public getUser<T = ICustomer>(publicId: string, observe: any = 'body', reportProgress: boolean = false): Observable<User<T>> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling getUser.');
        }

        return this.httpClient.get<User<T>>(`${this._kcmssvcURL}/users/${encodeURIComponent(String(publicId))}`,
            {

            }
        );
    }//end

    /**
     * update_user
     * Update a User
     * @param publicId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */

    public updateUser(publicId: string, body: User, reportProgress: boolean = false): Observable<any> {

        return this.httpClient.patch<User>(`${this._kcmssvcURL}/users/${encodeURIComponent(String(publicId))}`,
            body,
            {

            }
        );
    }//end



    //Password Change
    public changepassword(publicId: string, body: ChangePassword, reportProgress: boolean = false): Observable<any> {

        var bodyJson = { "password": body.newPassword };

        return this.httpClient.post<User>(`${this._kcmssvcURL}/users/${encodeURIComponent(String(publicId))}/change_password`,
            bodyJson,
            {
            }
        );
    }//end

    public forgotpassword(body: ForgotPassword, reportProgress: boolean = false) {
      const headers = new HttpHeaders().set('Content-Type', 'application/json');
      const options = { headers, responseType: 'text', observe: 'body' };

      return this.httpClient.post(`${this.authCurrentDomain}/dbconnections/change_password`, body, { headers, responseType: 'text'});
    }


   async getAsyncGrants(Application: string,userId: string){
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling getGrants.');
        }
        if (Application === null || Application === undefined) {
            throw new Error('Required parameter Application was null or undefined when calling getGrants.');
        }
        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if ( Application !== undefined ) {
            queryParameters = queryParameters.set('app', <any> Application);
        }

        return this.httpClient.get(`${this._kcmssvcURL}/users/`+ userId +`/grants?app=` + Application).toPromise();

    }

    async getUserDetails(publicId: string){
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling getUser.');
        }
        return this.httpClient.get<User>(`${this._kcmssvcURL}/users/${encodeURIComponent(String(publicId))}`).toPromise();
    }
}//end class
